<template>
    <div id="EnNavBar">
        <div id="nav-bar-pc">
            <header class="f16">
                <div class="wrap w1 bold">
                    <ul class="button-group">
                        <li v-for="(item, index) of relatedWebsites" :key="'related-website-' + index">
                            <a :href="item.href" target="_blank" role="button" tabindex="0"> <i :class="'icon-' + item.icon"></i>{{ item.title }} </a>
                        </li>
                    </ul>
                    <ul class="button-group">
                        <li>
                            <form id="search-form" class="search-form" action="https://www.google.com/search" target="_blank" role="search" method="get">
                                <i class="icon-search"></i>
                                <input type="hidden" name="sitesearch" value="recycle.moenv.gov.tw/MarineDebris" />
                                <input
                                    class="search-form-input"
                                    type="text"
                                    title="Search"
                                    v-model="searchText"
                                    name="q"
                                    placeholder="Search"
                                    autocomplete="off"
                                    @keypress.enter="submitSearch()"
                                />
                                <ul class="search-form-menu">
                                    <p>Trending Searches</p>
                                    <li
                                        v-for="(item, index) of commonSearch"
                                        :key="'search-form-menu-' + index"
                                        tabindex="0"
                                        role="button"
                                        @click="submitCommonSearch(item)"
                                        @keypress.enter="submitCommonSearch(item)"
                                    >
                                        {{ item }}
                                    </li>
                                </ul>
                            </form>
                        </li>
                        <li v-for="(item, index) of systemLinks" :key="'system-link-' + index">
                            <router-link :to="item.routeUrl" role="button" tabindex="0"> <i :class="'icon-' + item.icon"></i>{{ item.title }} </router-link>
                        </li>
                    </ul>
                </div>
            </header>
            <main class="f16">
                <div class="wrap w1">
                    <router-link class="logo-group" :to="{ name: 'EnHome' }">
                        <img :src="require('@/assets/png/logo.png')" alt="環境部資源循環署LOGO" />
                        <div class="logo-title-group">
                            <h4 class="f12">Environmental Protection Administration</h4>
                            <h3 class="f14 bold">
                                Recycled Marine Debris Product Label<br />
                                Information Zone
                            </h3>
                        </div>
                    </router-link>
                    <ul class="menu-list-group">
                        <li v-for="(item, index) of enNavItems" class="menu-list" :key="'menu-list' + index">
                            <button class="fw500">
                                {{ item.title }}
                            </button>
                            <ul class="menu">
                                <li v-for="(subitem, subindex) of item.items" :key="'menu-' + index + '-' + subindex">
                                    <router-link v-if="subitem.routeUrl" :to="subitem.routeUrl" tabindex="0" role="button" @click="blur" @keyup.enter="blur">{{
                                        subitem.title
                                    }}</router-link>
                                    <a v-else-if="subitem.href" :href="subitem.href" target="_blank" tabindex="0" role="button" @click="blur" @keyup.enter="blur">{{
                                        subitem.title
                                    }}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </main>
        </div>
        <div id="nav-bar-mobile">
            <header>
                <div class="burger-wrap" @click="toggle('burger')">
                    <i class="burger"> </i>
                </div>
                <router-link class="logo-group" :to="{ name: 'EnHome' }">
                    <img :src="require('@/assets/png/logo.png')" alt="環境部資源循環署LOGO" />
                    <div class="logo-title-group">
                        <h3 class="f12-mb bold">
                            Recycled Marine Debris<br />
                            Product Label Information Zone
                        </h3>
                    </div>
                </router-link>
                <div class="search-wrap" @click="toggle('search')">
                    <i class="icon-search"></i>
                </div>
            </header>
            <div class="mask" :class="{ activated: expanded !== null }" @click="toggle(null)"></div>
            <aside class="burger-group lh20" :class="{ activated: expanded === 'burger' }">
                <div class="close-wrap" @click="toggle(null)">
                    <i class="close"></i>
                </div>
                <div class="menu-list-group">
                    <div class="menu-list">
                        <h3 class="f18-mb bold">Related Websites</h3>
                        <ul class="f16-mb">
                            <li v-for="(item, index) of relatedWebsites" :key="'related-website-' + index">
                                <a :href="item.href" target="_blank" role="button" tabindex="0">
                                    {{ item.title }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="menu-list">
                        <h3 class="f18-mb bold">System Links</h3>
                        <ul class="f16-mb">
                            <li v-for="(item, index) of systemLinks" :key="'related-website-' + index">
                                <router-link v-if="item.routeUrl" :to="item.routeUrl" tabindex="0" role="button" @click="toggle(null)" @keyup.enter="toggle(null)">{{
                                    item.title
                                }}</router-link>
                                <a v-else-if="item.href" :href="item.href" target="_blank" tabindex="0" role="button" @click="toggle(null)" @keyup.enter="toggle(null)">{{
                                    item.title
                                }}</a>
                            </li>
                        </ul>
                    </div>
                    <div class="menu-list" v-for="(item, index) of enNavItems" :key="'menu-list' + index">
                        <h3 class="f18-mb bold">{{ item.title }}</h3>
                        <ul class="f16-mb">
                            <li v-for="(subitem, subindex) of item.items" :key="'menu-' + index + '-' + subindex">
                                <router-link v-if="subitem.routeUrl" :to="subitem.routeUrl" tabindex="0" role="button" @click="toggle(null)" @keyup.enter="toggle(null)">{{
                                    subitem.title
                                }}</router-link>
                                <a v-else-if="subitem.href" :href="subitem.href" target="_blank" tabindex="0" role="button" @click="toggle(null)" @keyup.enter="toggle(null)">{{
                                    subitem.title
                                }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </aside>
            <aside class="search-group" :class="{ activated: expanded === 'search' }">
                <form id="search-form" class="search-form" action="https://www.google.com/search" target="_blank" role="search" method="get">
                    <i class="icon-search"></i>
                    <input type="hidden" name="sitesearch" value="recycle.moenv.gov.tw/MarineDebris" />
                    <input
                        class="search-form-input"
                        type="text"
                        title="Search"
                        v-model="searchText"
                        name="q"
                        placeholder="Search"
                        autocomplete="off"
                        @keypress.enter="submitSearch()"
                    />
                </form>
                <ul class="search-form-menu">
                    <p class="f12-mb">Trending Searches</p>
                    <li
                        v-for="(item, index) of commonSearch"
                        :key="'search-form-menu-' + index"
                        tabindex="0"
                        role="button"
                        class="f14-mb"
                        @click="submitCommonSearch(item)"
                        @keypress.enter="submitCommonSearch(item)"
                    >
                        {{ item }}
                    </li>
                </ul>
            </aside>
        </div>
    </div>
</template>
<script>
export default {
    name: 'EnNavBar',
}
</script>

<script setup>
import { ref, watch } from 'vue'
import getNavItems from '@/data/getNavItems.js'
const { enNavItems } = getNavItems()
// button data
const relatedWebsites = [
    {
        icon: 'bureau',
        title: 'RECA',
        href: 'https://www.reca.gov.tw/en/',
    },
    {
        icon: 'recycle',
        title: 'Resource Recycling Website',
        href: 'https://recycle.moenv.gov.tw/',
    },
]
const systemLinks = [
    {
        icon: 'sitemap',
        title: 'Sitemap',
        routeUrl: { name: 'EnSitemap' },
    },
    {
        icon: 'translate',
        title: '中文',
        routeUrl: { name: 'Home' },
    },
]

// search data & function
const commonSearch = ['Statistics of marine debris', 'Beach cleanup ', 'Recycling supply chain', 'Recycled marine debris product label']
const searchText = ref('')
function submitSearch() {
    document.getElementById('search-form').submit()
}
async function submitCommonSearch(text) {
    searchText.value = text
    // console.log('HAHA')
    function searchTextReady() {
        if (searchText.value === text) {
            return new Promise((resolve) => resolve())
        }
    }
    await searchTextReady()
    submitSearch()
}
function blur(e) {
    e.target.blur()
}
// toggle burger & search group
const expanded = ref(null)
const toggle = function (tar) {
    expanded.value = tar
}

watch(expanded, (newVal) => {
    if (newVal) {
        document.body.style.height = '100vh'
        document.body.style.overflow = 'hidden'
    } else {
        document.body.style.height = 'auto'
        document.body.style.overflow = 'scroll'
    }
})
</script>
<style lang="scss" scoped>
// 設定不同寬度顯示
@media screen and (min-width: 768px) {
    #nav-bar-mobile {
        display: none;
        opacity: 0;
    }
}
@media screen and (max-width: 767px) {
    #nav-bar-pc {
        display: none;
        opacity: 0;
    }
}
// 設定於 hover & focus-within 時顯示
#nav-bar-pc {
    .search-form-menu {
        display: none;
        opacity: 0;
    }
    .search-form:focus-within .search-form-menu,
    .search-form:hover .search-form-menu {
        display: block;
        opacity: 1;
    }
    .menu {
        display: none;
        opacity: 0;
    }
    .menu-list:focus-within .menu,
    .menu-list:hover .menu {
        display: block;
        opacity: 1;
    }
}
// 一般 css 設定
#EnNavBar {
    position: relative;
    z-index: 1000;
    box-shadow: $shadow2;
}
#nav-bar-pc {
    @mixin menuStyle() {
        position: absolute;
        z-index: 90;
        background-color: $white;
        padding: 0.5em 0;
        box-shadow: $shadow1;
        p,
        li[role='button'],
        a[role='button'] {
            color: $gray6;
            font-size: 14px;
            font-weight: 500;
            line-height: 1.3em;
            letter-spacing: 0.02em;
            padding: 0.5em 1em;
            user-select: none;
        }
        li,
        a {
            cursor: pointer;

            &:hover,
            &:focus {
                background-color: $grayF;
            }
        }
    }
    .wrap {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    }
    header {
        color: $white;
        background-color: $theme1;
        .button-group {
            display: flex;
            a {
                display: block;
                padding: 1em 1.5em;
                transition: 0.3s;
                &:hover {
                    background-color: $theme0;
                    color: $theme3;
                }
            }
            i {
                position: relative;
                padding-right: 0.4em;
                top: 0.05em;
            }
            .search-form {
                position: relative;
                display: flex;
                align-items: center;
                height: 100%;
                padding: 0 1em;
            }
            input {
                position: relative;
                z-index: 100;

                display: block;
                padding: 0 0.8em;
                height: 2em;
                width: 10em;

                color: $gray6;
                font-size: 16px;
                letter-spacing: 0.1em;
                border-radius: 1.5em;
                border: none;
                &::placeholder {
                    color: $grayB;
                }
            }
            .search-form-menu {
                @include menuStyle();
                left: 4em;
                top: 80%;
            }
        }
    }
    main {
        position: relative;
        background-color: $white;
        .logo-group {
            display: flex;
            align-items: center;
            padding: 1em;

            img {
                display: block;
                margin-right: 20px;
                width: 60px;
                height: 60px;
            }
            h4 {
                margin-bottom: -0.2em;
                color: $gray6;
            }
            h2 {
                // margin-bottom: -0.2em;
                color: $theme3;
            }
            h3 {
                margin-bottom: 0.4em;
                line-height: 1.3em;
                color: $theme3;
            }
        }
        .menu-list-group {
            display: flex;
            align-items: center;
            color: $gray6;
            // height: 120px;
            .menu-list {
                position: relative;
                button {
                    width: 200px;
                    padding: 0.8em 20px;
                    line-height: 1.3em;
                    background-color: transparent;
                    border: none;
                    cursor: pointer;
                    transition: 0.3s;
                    &:hover {
                        color: $gray2;
                    }
                }
                .menu {
                    @include menuStyle();
                    a {
                        display: block;
                        width: 14em;
                        line-height: 1.2em !important;
                        padding: 1em !important;
                    }
                }
            }
        }
    }
}
#nav-bar-mobile {
    header {
        display: flex;
        padding: 10px;
        .burger-wrap,
        .search-wrap {
            flex: 0 0 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: $theme1;
        }
        .burger-wrap {
            i {
                &,
                &::before,
                &::after {
                    position: relative;
                    display: block;
                    width: 25px;
                    height: 3px;
                    border-radius: 2px;
                    background-color: $theme1;
                }

                &::before,
                &::after {
                    content: '';
                }
                &::before {
                    top: -9px;
                }
                &::after {
                    bottom: -6px;
                }
            }
        }
        .search-wrap {
            font-size: 28px;
        }
        .logo-group {
            flex: 1;
            display: flex;
            margin: 5px 15px;
            justify-content: center;
            align-items: center;
            color: $theme3;
            line-height: 1em;
            img {
                width: 30px;
                height: 30px;
                margin-right: 10px;
            }
        }
    }
    .mask {
        display: none;
        opacity: 0;
        position: absolute;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba($black, 0.5);
        transition: 0.3s;

        &.activated {
            display: block;
            opacity: 1;
        }
    }
    .burger-group {
        opacity: 0;
        position: absolute;
        left: -60vw;
        top: 0;
        box-sizing: border-box;
        padding-top: 70px;
        width: 60vw;
        height: 100vh;
        color: $gray6;
        background-color: $white;
        box-shadow: $shadow2;
        transition: 0.3s;
        &.activated {
            opacity: 1;
            left: 0;
        }
        .close-wrap {
            position: absolute;
            right: 0;
            top: 0;
            padding: 10px;
            width: 50px;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;

            i {
                &::before,
                &::after {
                    content: '';
                    position: relative;
                    display: block;
                    width: 25px;
                    height: 3px;
                    border-radius: 2px;
                    background-color: $theme1;
                }
                &:before {
                    top: 1.5px;
                    transform: rotate(45deg);
                }
                &:after {
                    bottom: 1.5px;
                    transform: rotate(-45deg);
                }
            }
        }
        .menu-list-group {
            box-sizing: border-box;
            padding: 0 30px 100px;
            height: calc(100vh - 70px);
            overflow-y: scroll;
            overflow-x: hidden;
        }
        .menu-list {
            h3,
            ul > li {
                line-height: 1.2em;
                padding: 0.4em 0;
            }
            ul {
                margin-bottom: 1.5em;
            }
        }
    }
    .search-group {
        opacity: 0;
        position: absolute;
        left: 0;
        top: -200px;
        box-sizing: border-box;
        padding: 20px;
        width: 100vw;
        color: $gray6;
        background-color: $white;
        box-shadow: $shadow2;
        transition: 0.3s;
        &.activated {
            opacity: 1;
            top: 0;
        }
        .search-form {
            display: flex;
            align-items: center;
        }
        i {
            width: 2em;
            text-align: center;
        }
        input {
            flex: 1;

            display: block;
            padding: 0 0.8em;
            height: 2em;
            color: $gray6;
            font-size: 16px;
            border: 1px solid $grayB;
            border-radius: 1.5em;
            &::placeholder {
                color: $grayB;
            }
        }
        .search-form-menu {
            margin-top: 20px;
            padding: 0 10px;
            text-align: center;
        }
    }
}
</style>
